<template>
  <nx-bform class="login-form" @submit="login">
    <h5>{{ $t("title") }}</h5>

    <nx-bform-server-errors />

    <LoginNameFormGroup v-model="identity.username" required />

    <LoginPasswordFormGroup v-model="identity.password" required />

    <b-button type="submit" variant="primary">{{ $t("login") }}</b-button>
  </nx-bform>
</template>

<script>
import { UserApi } from "nx-libs";
import LoginPasswordFormGroup from "@/forms/login/LoginPasswordFormGroup";
import LoginNameFormGroup from "@/forms/login/LoginNameFormGroup";
import LoginRoleFormGroup from "@/forms/login/LoginRoleFormGroup";

export default {
  components: {
    LoginPasswordFormGroup,
    LoginNameFormGroup,
    LoginRoleFormGroup
  },
  data() {
    return {
      identity: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    async login() {
      const { username, password } = this.identity;

      await UserApi.login(
        1,
        {
          Username: username,
          Password: password
        },
        false
      );

      window.location.href = process.env.VUE_APP_EPS_URL;
      console.log(process.env.VUE_APP_EPS_URL);
    }
  }
};
</script>

<style lang="scss" scoped></style>

<i18n src="@/locales/login.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>

<i18n>
{
  "en": {
    "title": "Login",
    "query": {
      "forgetPassword": "Forget @.lower:password?",
      "forgetLoginName": "Forget @.lower:loginName?",
      "registerPublicUser": "Register a @.lower:users.publicUser account?",
      "activateProfessional": "Activate a registered @.lower:users.professional or @.lower:users.contractor account?"
    }
  },
  "zh_hk": {
    "title": "登入",
    "query": {
      "forgetPassword": "忘記@:password?",
      "forgetLoginName": "忘記@:loginName?",
      "registerPublicUser": "註冊一個@:users.publicUser帳戶?",
      "activateProfessional": "啟用一個已註冊@:users.professional或@:users.contractor帳戶?"
    }
  },
  "zh_cn": {
    "title": "登入",
    "query": {
      "forgetPassword": "忘记@:password?",
      "forgetLoginName": "忘记@:loginName?",
      "registerPublicUser": "注册一个@:users.publicUser 帐户?",
      "activateProfessional": "启用一個已註冊@:users.professional或@:users.contractor帳戶?"
    }
  }
}
</i18n>
